import { api } from 'services/api'

export const getSingleContratos = async (idContrato) => {
  let url = `contratos/${idContrato}`

  const response = await api.get(url)

  return response.data.data
}
